import { HttpHeaders, HttpRequest } from '@angular/common/http';

export const ORG_ID_HEADER_KEY = 'orgId';
export const WITH_ORG_ID_FLAG_KEY = 'withOrgId';
export const WITH_MANUAL_ORG_ID_FLAG_KEY = 'withManualOrgId';

export function hasRequestHeader(request: HttpRequest<unknown>, headerName: string): boolean {
  return request.headers.has(headerName);
}

export function removeHeaderFromRequest(request: HttpRequest<unknown>, headerName: string) {
  if (request.headers.has(headerName)) {
    return request.clone({ headers: request.headers.delete(headerName) });
  }

  return request;
}

export function addHeaderToRequest(request: HttpRequest<unknown>, headerName: string, value: string | string[]) {
  return request.clone({ headers: request.headers.set(headerName, value) });
}

export function createHeaders(headerName: string, value: string | string[]): HttpHeaders {
  return new HttpHeaders({ [headerName]: value });
}

export function withOrgId(): HttpHeaders {
  return createHeaders(WITH_ORG_ID_FLAG_KEY, 'true');
}

export function withManualOrgId(): HttpHeaders {
  return createHeaders(WITH_MANUAL_ORG_ID_FLAG_KEY, 'true');
}
